import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, Subject, takeUntil } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { ModalService } from 'src/app/services/modal.service';
import { OfflineStorageService } from 'src/app/services/offline-storage.service';
import { SharedService } from 'src/app/services/shared.service';
import { AppState } from 'src/app/store/app.state';
import { getUser } from 'src/app/store/selectors/account.selector';

@Component({
  selector: 'app-admin-layout',
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.scss']
})
export class AdminLayoutComponent implements OnInit, OnDestroy {

  getUserProfile$: Observable<any>;
  userProfile: any;

  ngUnsubscribe = new Subject<void>();

  @ViewChild('sidenav') sidenav!: MatSidenav;

  constructor(
    private store: Store<AppState>,
    private sharedService: SharedService,
    public router: Router,
    private authService: AuthService,
    private modalService: ModalService,
    private offlineStorageService: OfflineStorageService
  ) { 
    this.getUserProfile$ = this.store.select(getUser);
  }

  async ngOnInit() {
    this.sharedService.sidenavToggle$.subscribe(() => {
      this.sidenav.toggle();
    });

    this.getUserProfile$.pipe(takeUntil(this.ngUnsubscribe)).subscribe(async (res) => {
      const user = await this.offlineStorageService.getObject('user'); 
      if(user){
        this.userProfile = JSON.parse(user);
      }
    });
  }
  
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  logout(){
    // this.router.navigateByUrl('/landing/home')
    this.router.navigateByUrl('/auth/login');
    this.authService.logout().toPromise().then((res) => {
      if(res){
        console.log(res);
      }
    }).catch((err) => {
      const error = {
        message: err?.error?.message
      }
      this.modalService.errorModal(error);
    })
  }

}
